import { apiConstants } from "@data/constants/apiConstants"
import { tutorsService } from "@data/services/tutorsService"
import { tutorTrainingService } from "@data/services/tutorTrainingService"

// ** Initial State
const initialState = {
    notes: [],
    testQuestions: [],
    testAnswers: [],
    tutoringInvoices: [],
    liveOccurrences: [],
    tasks: {
        prepare_live: null,
        missing_reports: null,
        complete_profile: null,
        update_availability: null,
        stripe_account: null,
        training_videos: null,
        lastFetchTime: null,
    },
}

export function tutors(state = initialState, action) {
    switch (action.type) {
        case tutorsService.submitTestAnswer.name + apiConstants._SUCCESS:
        case tutorsService.submitTestVideo.name + apiConstants._SUCCESS:
            return {
                ...state,
                testAnswers: state.testAnswers
                    ?.map((ta) => ta?.id)
                    ?.includes(action.data?.id)
                    ? state.testAnswers.map((x) =>
                          x.id === action.data?.id ? action.data : x
                      )
                    : state.testAnswers.concat(action.data),
            }

        case tutorsService.getTestQuestions.name + apiConstants._SUCCESS:
            return {
                ...state,
                testQuestions: action.data?.application_questions,
                testAnswers: action.data?.application_answers,
            }

        case tutorsService.updateNote.name + apiConstants._SUCCESS:
            return {
                ...state,
                notes: state.notes.map((n) =>
                    n.id === action.data?.id ? action.data : n
                ),
            }

        case tutorsService.postNote.name + apiConstants._SUCCESS:
            return {
                ...state,
                notes: [action.data].concat(state.notes),
            }
        case tutorsService.deleteNote.name + apiConstants._SUCCESS:
            return {
                ...state,
                notes: state.notes.filter(
                    (n) => n?.id !== action.routeParams?.id
                ),
            }
        case tutorsService.getNotes.name + apiConstants._SUCCESS:
            let newNotes = []

            if (action.data?.meta?.current_page === 1) {
                // Refresh
                newNotes = action.data?.tutor_notes
            } else {
                // Concat
                newNotes = state?.notes.concat(action.data?.tutor_notes)
            }

            return {
                ...state,
                notes: newNotes,
            }

        case tutorsService.getTutoringInvoices.name + apiConstants._SUCCESS:
            let tutoringInvoices = []

            if (action.data?.meta?.current_page === 1) {
                // Refresh
                tutoringInvoices = action.data?.tutoring_invoices
            } else {
                // Concat
                tutoringInvoices = state?.tutoringInvoices.concat(
                    action.data?.tutoring_invoices
                )
            }

            return {
                ...state,
                tutoringInvoices: tutoringInvoices,
            }

        case tutorsService.generateFullPdf.name + apiConstants._SUCCESS:
            return {
                ...state,
                tutoringInvoices: state.tutoringInvoices.map((invoice) =>
                    invoice.id === action.data.id ? action.data : invoice
                ),
            }

        // case tutorsService.deleteOccurrence.name + apiConstants._SUCCESS:
        //     return {
        //         ...state,
        //         liveOccurrences: state?.liveOccurrences?.filter(
        //             (occurrence) => occurrence?.id !== action?.routeParams?.id
        //         ),
        //     };
        // case tutorsService.editBilling.name + apiConstants._SUCCESS:
        //     return {
        //         ...state,
        //         liveOccurrences: state.liveOccurrences.map((occurrence) => {
        //             if (occurrence?.id === action?.data?.id) {
        //                 return action?.data;
        //             }
        //             return occurrence;
        //         }),
        //     };

        case tutorsService.getTutorLiveOccurrences.name + apiConstants._SUCCESS:
            let liveOccurrences = []
            if (action.data?.meta?.current_page === 1) {
                liveOccurrences = action.data?.live_occurrences
            } else {
                liveOccurrences = state.liveOccurrences?.concat(
                    action.data?.live_occurrences
                )
            }
            return {
                ...state,
                liveOccurrences,
            }

        case tutorsService.getTutorTasks.name + apiConstants._SUCCESS:

            // Try to get data from action.all_data first, then action.data
            const tasksData = action.data|| {}


            return {
                ...state,
                tasks: {
                    prepare_live: tasksData.prepare_live || null,
                    missing_reports: tasksData.missing_reports || null,
                    complete_profile: tasksData.complete_profile || null,
                    update_availability: tasksData.update_availability || null,
                    stripe_account: tasksData.stripe_account || null,
                    training_videos: tasksData.training_videos || null,
                    lastFetchTime: Date.now(),
                },
            }

        // A pass takes the training card off the home screen at once, without
        // waiting for the next tasks fetch.
        case tutorTrainingService.submitTutorTrainingQuiz.name +
            apiConstants._SUCCESS:
            if (action.data?.progress?.status !== "passed") return state
            return {
                ...state,
                tasks: {
                    ...state.tasks,
                    training_videos: {
                        ...state.tasks?.training_videos,
                        required: false,
                        status: "passed",
                    },
                },
            }

        default:
            return state
    }
}

export default tutors
